import { ReactComponent as FileCheckIcon } from '../../../../assets/Icons/file-check.svg';
import { PersonaInquiryType } from '@sandtech-hub-monorepo/ehub-client';
import { PersonaVerification } from './PersonaVerification';

type PersonaHighSchoolVerificationProps = {
  programApplicationId: string;
  close: () => void;
} & (
  | {
      hasChosenPersona: false;
      onSwitchToManual: () => void;
    }
  | {
      hasChosenPersona: true;
      onSwitchToManual?: () => void;
    }
);

export const PersonaHighSchoolVerification = ({
  programApplicationId,
  close,
  hasChosenPersona,
  onSwitchToManual,
}: PersonaHighSchoolVerificationProps) => {
  return (
    <PersonaVerification
      icon={<FileCheckIcon height="48" width="48" />}
      title="High School Certificate Verification"
      description="Please follow the instructions to verify your certificate."
      programApplicationId={programApplicationId}
      inquiryType={PersonaInquiryType.Highschool}
      close={close}
      fallbackAction={
        // Only show manual fallback if user hasn't already chosen persona verification
        !hasChosenPersona
          ? {
              text: 'If you do not have access to your school certificate anymore, please',
              onClick: onSwitchToManual,
            }
          : undefined
      }
    />
  );
};
